import React, { useEffect, useState } from 'react';
import { node } from 'prop-types';
import NikeDotcomNav from '../utils/nikeDotcomNav/nikeDotcomNav';
import { NAV_CUSTOM_EVENTS } from '../constants';

const initialState = { opts: new NikeDotcomNav().opts, mounted: false };
const NavOptionsContext = React.createContext(initialState);

/**
 * Exposes the nav mount options provided from an experience
 * Also adds a mounted property so child components can perform side affects
 * based on if the nav has been mounted. See analyticsContext.js
 */
function useNavOptions() {
  const [navOptions, setNavOptions] = useState(initialState);

  useEffect(() => {
    const onMountHandler = () => {
      const { opts, mounted } = window.NikeDotcomNav;
      setNavOptions({ opts, mounted });
    };
    // NikeDotcomNav is already mounted and has our options ready for us
    if (window.NikeDotcomNav?.mounted) {
      onMountHandler();
      return;
    }
    // Sometimes NikeDotcomNav is not on the window yet
    // This event listener will fire when NikeDotcomNav exists and is mounted
    window.addEventListener(NAV_CUSTOM_EVENTS.MOUNTED, onMountHandler);
    return () => window.removeEventListener(NAV_CUSTOM_EVENTS.MOUNTED, onMountHandler);
  }, []);

  return navOptions;
}

export const NavOptionsProvider = props => (
  <NavOptionsContext.Provider value={useNavOptions()} {...props} />
);

export const useNavOptionsContext = () => React.useContext(NavOptionsContext);

NavOptionsProvider.propTypes = {
  children: node,
};
